import React from 'react';
import './RoadMap.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';

export default function RoadMap() {
    return (
        <div className="roadmap w-100 h-100 roadmap-container" id="RoadMap1">
            <h1 className="text-center product-style">
                Product <span className="roadmap-style">Roadmap</span>
            </h1>
            <Container className="container-padding">
                <div className="timeline-bg-color">
                    <div className="roadmap-timeline" />
                </div>
            </Container>
        </div>
    );
}
